// extracted by mini-css-extract-plugin
module.exports = {"noDataFoundSection":"NothingToReportOverlay_noDataFoundSection__24M9C","noDataText":"NothingToReportOverlay_noDataText__3-tiW","subText":"NothingToReportOverlay_subText__GHka8"};